import { HighlightColorVariant, HighlightColorVariantEnum } from '../types';

export const TimepubHighlightColorMap: Record<string, string> = {
  HLColor1: 'red',
  HLColor2: 'blue',
  HLColor3: 'yellow',
};

export const HighlightColorMap: Record<
  string,
  { backgroundColor: string; focus: string }
> = {
  yellow: {
    backgroundColor: 'rgba(247, 239, 187, 1)',
    focus: 'rgba(240, 224, 120, 0.9)',
  },
  red: {
    backgroundColor: 'rgba(239, 183, 183, 1)',
    focus: 'rgba(239, 183, 183, 1)',
  },
  blue: {
    backgroundColor: 'rgba(183, 238, 239, 1)',
    focus: 'rgba(183, 238, 239, 1)',
  },
  green: {
    backgroundColor: 'rgba(189, 239, 183, 1)',
    focus: 'rgba(189, 239, 183, 1)',
  },
  lilac: {
    backgroundColor: 'rgba(208, 206, 252, 1)',
    focus: 'rgba(208, 206, 252, 1)',
  },
  none: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    focus: 'rgba(255, 255, 255, 1)',
  },
};

export function getHighlightRGBA(
  color?: string | null,
  variant?: HighlightColorVariant,
): string {
  if (!color || !Object.keys(HighlightColorMap).includes(color)) {
    const defaultColor = HighlightColorMap['none'];
    return defaultColor[variant ?? HighlightColorVariantEnum.backgroundColor];
  }

  return HighlightColorMap[color][
    variant ?? HighlightColorVariantEnum.backgroundColor
  ];
}
